import React from "react";
import { Bell, Plus, Menu } from "lucide-react";
import "./layout.scss";

interface HeaderProps {
  onMenuClick: () => void;
  rightActions?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, rightActions }) => {
  return (
    <header className="header">
      <button className="menu-btn" onClick={onMenuClick}>
        <Menu size={24} />
      </button>

      <h1 className="title">ChargingAdda’s Charging Management Software</h1>

      <div className="actions">
        <button className="bell-btn">
          <Bell size={18} />
        </button>
        {/* <button className="add-btn">
          <Plus size={18} /> Add charger
        </button> */}
        {rightActions}
      </div>
    </header>
  );
};

export default Header;
